export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/assets/logo.webp"
    alt="Taxi Bellinzona"
    width={size}
    height={size}
    className={`rounded-full object-cover ${className}`}
    style={{ objectPosition: "50% 22%" }}
  />
);

export const LogoLockup = ({ size = 36 }) => (
  <div className="flex items-center gap-3" data-testid="nav-brand-logo">
    <LogoMark size={size} />
    <div className="hidden leading-none min-[420px]:block">
      <span className="block font-display text-sm font-extrabold tracking-[0.18em] text-white">
        TAXI BELLINZONA
      </span>
      <span className="mt-1 block font-mono-alt text-[10px] uppercase tracking-[0.3em] text-amber-400">
        Ticino • 24/7
      </span>
    </div>
  </div>
);
